// @generated by protoc-gen-connect-es v1.3.0 with parameter "target=ts"
// @generated from file castes.proto (package nail2poll, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { Caste, CastePaginationResp, CastesList, CastesServiceCreateRequest, CastesServiceFilterReq, CastesServicePaginationReq, CastesServiceSearchAllReq, CastesServiceUpdateRequest } from "./castes_pb.js";
import { MethodKind } from "@bufbuild/protobuf";
import { ActiveRequest, CountRequest, CountResponse, CSVImport, ErroredResponse, Identifier, IdentifierWithUserComment, StandardFile } from "./base_pb.js";

/**
 *
 * Describes the methods applicable on each caste
 *
 * @generated from service nail2poll.CastesService
 */
export const CastesService = {
  typeName: "nail2poll.CastesService",
  methods: {
    /**
     * Create a caste
     *
     * @generated from rpc nail2poll.CastesService.Create
     */
    create: {
      name: "Create",
      I: CastesServiceCreateRequest,
      O: Caste,
      kind: MethodKind.Unary,
    },
    /**
     * Update a caste
     *
     * @generated from rpc nail2poll.CastesService.Update
     */
    update: {
      name: "Update",
      I: CastesServiceUpdateRequest,
      O: Caste,
      kind: MethodKind.Unary,
    },
    /**
     * Archive the caste
     *
     * @generated from rpc nail2poll.CastesService.Archive
     */
    archive: {
      name: "Archive",
      I: IdentifierWithUserComment,
      O: Identifier,
      kind: MethodKind.Unary,
    },
    /**
     * Restore the caste
     *
     * @generated from rpc nail2poll.CastesService.Restore
     */
    restore: {
      name: "Restore",
      I: IdentifierWithUserComment,
      O: Identifier,
      kind: MethodKind.Unary,
    },
    /**
     * View by UUID
     *
     * @generated from rpc nail2poll.CastesService.ViewByUUID
     */
    viewByUUID: {
      name: "ViewByUUID",
      I: Identifier,
      O: Caste,
      kind: MethodKind.Unary,
    },
    /**
     * View all castes
     *
     * @generated from rpc nail2poll.CastesService.ViewAll
     */
    viewAll: {
      name: "ViewAll",
      I: ActiveRequest,
      O: CastesList,
      kind: MethodKind.Unary,
    },
    /**
     * View castes with pagination
     *
     * @generated from rpc nail2poll.CastesService.ViewWithPagination
     */
    viewWithPagination: {
      name: "ViewWithPagination",
      I: CastesServicePaginationReq,
      O: CastePaginationResp,
      kind: MethodKind.Unary,
    },
    /**
     * View all that match the given search key
     *
     * @generated from rpc nail2poll.CastesService.SearchAll
     */
    searchAll: {
      name: "SearchAll",
      I: CastesServiceSearchAllReq,
      O: CastesList,
      kind: MethodKind.Unary,
    },
    /**
     * View all that match the given filter criteria
     *
     * @generated from rpc nail2poll.CastesService.Filter
     */
    filter: {
      name: "Filter",
      I: CastesServiceFilterReq,
      O: CastesList,
      kind: MethodKind.Unary,
    },
    /**
     * Count
     *
     * @generated from rpc nail2poll.CastesService.Count
     */
    count: {
      name: "Count",
      I: CountRequest,
      O: CountResponse,
      kind: MethodKind.Unary,
    },
    /**
     * ------------------------------------------------------
     * Import and Export operations are listed below
     * Import from CSV file
     *
     * @generated from rpc nail2poll.CastesService.Import
     */
    import: {
      name: "Import",
      I: CSVImport,
      O: ErroredResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Export to CSV file
     *
     * @generated from rpc nail2poll.CastesService.Export
     */
    export: {
      name: "Export",
      I: CastesServiceFilterReq,
      O: StandardFile,
      kind: MethodKind.Unary,
    },
  }
} as const;

